module.exports = __webpack_public_path__ + "img/israel.48b4590b.jpeg";